var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "667",
        height: "667",
        viewBox: "0 0 667 667",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M333.333 641.667C503.621 641.667 641.667 503.621 641.667 333.333C641.667 163.046 503.621 25 333.333 25C163.046 25 25 163.046 25 333.333C25 503.621 163.046 641.667 333.333 641.667Z",
          stroke: "#14B9EC",
          "stroke-width": "50",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M333.333 641.667C402.369 641.667 458.333 503.621 458.333 333.333C458.333 163.046 402.369 25 333.333 25C264.298 25 208.333 163.046 208.333 333.333C208.333 503.621 264.298 641.667 333.333 641.667Z",
          stroke: "#14B9EC",
          "stroke-width": "50",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M50 233.333H616.667M50 433.333H616.667",
          stroke: "#14B9EC",
          "stroke-width": "50",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }